import React from "react";
import { TaskItemProps } from "../task-item";
import styles from "./project.module.css";

export const Project: React.FC<TaskItemProps> = ({
  task,
  isSelected,
  isDateChangeable,
  onEventStart,
}) => {
  const barColor = isSelected
    ? task.styles.backgroundSelectedColor
    : task.styles.backgroundColor;
  const processColor = isSelected
    ? task.styles.progressSelectedColor
    : task.styles.progressColor;
  const projectWidth = task.x2 - task.x1;

  const projectLeftTriangle = [
    task.x1,
    task.y + task.height / 2 - 1,
    task.x1,
    task.y + task.height,
    task.x1 + 15,
    task.y + task.height / 2 - 1,
  ].join(",");
  const projectRightTriangle = [
    task.x2,
    task.y + task.height / 2 - 1,
    task.x2,
    task.y + task.height,
    task.x2 - 15,
    task.y + task.height / 2 - 1,
  ].join(",");

  return (
    <g 
      tabIndex={0} 
      className={styles.projectWrapper}         
      onMouseDown={e => {
          isDateChangeable && onEventStart("move", task, e);
      }}>
      {/* Background rectangle with move handler */}
      <rect
        fill={barColor}
        x={task.x1}
        width={projectWidth}
        y={task.y}
        height={task.height}
        rx={task.barCornerRadius}
        ry={task.barCornerRadius}
        className={styles.projectBackground}

      />
      
      {/* Progress bar */}
      <rect
        x={task.progressX}
        width={task.progressWidth}
        y={task.y}
        height={task.height}
        ry={task.barCornerRadius}
        rx={task.barCornerRadius}
        fill={processColor}

      />
      
      {/* Top decorative elements */}
      <rect
        fill={barColor}
        x={task.x1}
        width={projectWidth}
        y={task.y}
        height={task.height / 2}
        rx={task.barCornerRadius}
        ry={task.barCornerRadius}
        className={styles.projectTop}
      />
      <polygon
        className={styles.projectTop}
        points={projectLeftTriangle}
        fill={barColor}
      />
      <polygon
        className={styles.projectTop}
        points={projectRightTriangle}
        fill={barColor}
      />
        {task?.description && task?.description.length > 0 && (
            <foreignObject
                x={task.x1 + projectWidth - task.height * 0.55}
                y={task.y + task.height * 0.11}
                width={task.height * 0.5}
                height={task.height * 0.5}
            >
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <i className="pi pi-info-circle" style={{color: 'white', fontSize: `${task.height * 0.4}px`}}/>
                </div>
            </foreignObject>
        )}
      
    </g>
  );
};